import { IRowNode } from 'ag-grid-community';

export function stringComparator(a: string, b: string) {
    const aa = a?.toLocaleLowerCase();
    const bb = b?.toLocaleLowerCase();
    if (aa == bb) {
        return 0;
    }
    return aa > bb ? 1 : -1;
}

export function numberFieldComparator(field: string) {
    return (_: any, __: any, a: IRowNode, b: IRowNode) =>
        a?.data?.[field] - b?.data?.[field];
}

export function numberFieldPropertyComparator(field: string, property: string) {
    return (_: any, __: any, a: IRowNode, b: IRowNode) =>
        a?.data?.[field]?.[property] - b?.data?.[field]?.[property];
}

export const DATE_CELL_COMPARATOR = (dateA: string, dateB: string) =>
    new Date(dateA).getTime() - new Date(dateB).getTime();
